import { getDbSupabase, supabase } from './supabase';

export type DemSslSyncResult = {
  ok: boolean;
  rows?: number;
  fetched?: number;
  skipped_expired?: number;
  skipped_blank_item?: number;
  skipped_ipg?: number;
  skipped_dim2?: number;
  deactivated?: number;
  soft_delete_skipped?: boolean;
  soft_delete_skip_reason?: string | null;
  active_before?: number;
  preserved?: number;
  source_total?: number | null;
  version?: string;
  actor?: string;
  duration_ms?: number;
  error?: string;
};

async function invokeDemPowerBiSync(
  functionName:
    | 'dem-ssl-sync-from-powerbi'
    | 'dem-prices-sync-from-powerbi'
    | 'dem-items-sync-from-powerbi'
    | 'dem-customers-sync-from-powerbi',
): Promise<DemSslSyncResult> {
  const url = import.meta.env.VITE_SUPABASE_URL?.replace(/\/$/, '');
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
  if (!url || !anonKey) {
    throw new Error('Supabase is not configured.');
  }

  const authClient = supabase ?? getDbSupabase('dem');
  const { data: sessionData, error: sessionError } = await authClient.auth.getSession();
  if (sessionError) throw new Error(sessionError.message);
  const token = sessionData.session?.access_token?.trim();
  if (!token) throw new Error('Sign in required to sync master data from PowerBI.');

  const res = await fetch(`${url}/functions/v1/${functionName}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: anonKey,
      Authorization: `Bearer ${token}`,
    },
    body: '{}',
  });

  const body = (await res.json().catch(() => ({}))) as DemSslSyncResult;
  if (!res.ok || body.ok === false) {
    throw new Error(body.error || `Sync failed (HTTP ${res.status}).`);
  }
  return body;
}

export async function syncDemStandardSalesLinesFromPowerBi(): Promise<DemSslSyncResult> {
  return invokeDemPowerBiSync('dem-ssl-sync-from-powerbi');
}

export async function syncDemPricesFromPowerBi(): Promise<DemSslSyncResult> {
  return invokeDemPowerBiSync('dem-prices-sync-from-powerbi');
}

export async function syncDemItemsFromPowerBi(): Promise<DemSslSyncResult> {
  return invokeDemPowerBiSync('dem-items-sync-from-powerbi');
}

export async function syncDemCustomersFromPowerBi(): Promise<DemSslSyncResult> {
  return invokeDemPowerBiSync('dem-customers-sync-from-powerbi');
}
